import { render } from "./ImportTemplateModal.vue?vue&type=template&id=3c56afc4&scoped=true"
import script from "./ImportTemplateModal.vue?vue&type=script&lang=ts"
export * from "./ImportTemplateModal.vue?vue&type=script&lang=ts"

import "./ImportTemplateModal.vue?vue&type=style&index=0&id=3c56afc4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3c56afc4"

export default script